<template>
    <div class="audio-block">
        <v-layout wrap row>
            <v-flex v-for="(mp3, index) in song" :key="index" class="pa-3 my-1 border">
                        <h4>{{mp3.title}}</h4>
                        <p class="author">{{mp3.author}}</p>
                        <p v-if="mp3.description">{{ mp3.description }}</p>                        
                        <audio controls>
                            <source :src="`/audio/${mp3.song}`" type="audio/mpeg">
                                Your browser does not support the audio element.
                        </audio> 

            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        props: ['song']
    }
</script>

<style>
    .author {
        color: #C4B384;
    }
    .audio-block h4 {
        font-family: 'Open Sans Condensed', sans-serif;
        color: #c0c0c0;
        margin: auto;
        font-size: 26px;
        font-weight: normal!important;
        display: inline-block!important;
    }
    .border {
        border: 1px dotted #999;
    }
</style>
